import { Badge, Code, DataList, Dialog, Portal } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { reportInfo } from "../../Redux/Action";
import { formatDateTime } from "../../Utils/newHelper";
import { TransactionInfoSkeleton } from "./Skeletons/TransactionInfoSkeleton";

export const TransactionInfoDialog = ({
  token,
  setToken,
  transactionInfoDialogOpen,
  setTransactionInfoDialogOpen,
}) => {
  const [transactionInfo, setTransactionInfo] = useState([]);
  const [isDataLoading, setisDataLoading] = useState(true);
  const dispatch = useDispatch();

  const getRefundableBadge = (availableForRefund) => {
    return (
      <Badge
        colorPalette={availableForRefund ? "green" : "red"}
        variant="surface"
      >
        {availableForRefund ? "Refundable" : "Non-Refundable"}
      </Badge>
    );
  };

  useEffect(() => {
    dispatch(
      reportInfo({
        token: token,
        callback: (data) => {
          if (data?.meta?.code === 200) {
            const formattedData = [
              {
                label: "Amount",
                value: (
                  <Badge colorPalette="green" size="md">
                    {data?.data?.amount}
                  </Badge>
                ),
              },
              { label: "Currency", value: data?.data?.currency },
              { label: "Email", value: data?.data?.email },
              { label: "Status", value: data?.data?.status },
              {
                label: "IP",
                value: <Code variant="outline">{data?.data?.ip}</Code>,
              },
              { label: "Transaction ID", value: data?.data?.order_number },
              { label: "Operation Type", value: data?.data?.operation_type },
              {
                label: "Available for Refund",
                value: getRefundableBadge(data?.data?.available_for_refund),
              },
              {
                label: "Created At",
                value: formatDateTime(data?.data?.created_at),
              },
            ];
            setTransactionInfo(formattedData);
            setisDataLoading(false);
          }
        },
      })
    );
  }, []);

  return (
    <Dialog.Root
      size="xs"
      placement="center"
      motionPreset="scale"
      open={transactionInfoDialogOpen}
      onOpenChange={(e) => {
        setTransactionInfoDialogOpen(e.open);
        if (!e.open) {
          setTransactionInfo({});
          setToken("");
        }
      }}
    >
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content>
          <Dialog.Header textAlign="center">
            <Dialog.Title>Transaction Info</Dialog.Title>
            <Dialog.CloseTrigger />
          </Dialog.Header>
          <Dialog.Body>
            {isDataLoading ? (
              <TransactionInfoSkeleton />
            ) : (
              <DataList.Root orientation="horizontal" divideY="1px" maxW="md">
                {transactionInfo.map((item) => (
                  <DataList.Item key={item.label} pt="4">
                    <DataList.ItemLabel width="40%" fontSize="xs">
                      {item.label}
                    </DataList.ItemLabel>
                    <DataList.ItemValue fontSize="xs">
                      {item.value}
                    </DataList.ItemValue>
                  </DataList.Item>
                ))}
              </DataList.Root>
            )}
          </Dialog.Body>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
};
